// extracted by mini-css-extract-plugin
export default {"underlinedWord":"underlinedWord--28Rsv","glossaryLink":"glossaryLink--QqvDw"};